<div class="user-edit">
  <h2>{{ isNew ? 'Add User' : 'Edit User' }}</h2>

  <dx-form [formData]="formData" [colCount]="2" labelLocation="top">
    <dxi-item dataField="name" editorType="dxTextBox" [label]="{ text: 'Name' }">
      <dxi-validation-rule type="required" message="Name is required"></dxi-validation-rule>
    </dxi-item>

    <dxi-item dataField="email" editorType="dxTextBox"
      [label]="{ text: 'Email' }"
      [editorOptions]="{ mode: 'email', readOnly: !isNew }">
      <dxi-validation-rule type="required" message="Email is required"></dxi-validation-rule>
      <dxi-validation-rule type="email" message="Email is invalid"></dxi-validation-rule>
    </dxi-item>

    <dxi-item dataField="password" editorType="dxTextBox"
      [label]="{ text: isNew ? 'Password' : 'New password (leave blank to keep)' }"
      [editorOptions]="{ mode: 'password' }"></dxi-item>

    <dxi-item dataField="theme" editorType="dxNumberBox" [label]="{ text: 'Theme' }"></dxi-item>
  </dx-form>

  <div class="actions">
    <dx-button text="Save" type="default" (onClick)="save()"></dx-button>
    <dx-button text="Cancel" (onClick)="cancel()"></dx-button>
  </div>

  <div class="roles-editor" *ngIf="!isNew">
    <div class="roles-header">
      <h3>Roles</h3>
      <div class="add-grant">
        <dx-select-box [dataSource]="locations" valueExpr="id" displayExpr="name"
          placeholder="Location" [(value)]="newGrant.location_id"></dx-select-box>
        <dx-select-box [dataSource]="roles" valueExpr="id" displayExpr="name"
          placeholder="Role" [(value)]="newGrant.role_id"></dx-select-box>
        <dx-button text="Add role" icon="plus" (onClick)="addGrant()"></dx-button>
      </div>
    </div>

    <div class="roles-grid-wrap">
      <dx-data-grid
        [dataSource]="grants"
        [keyExpr]="['location_id', 'role_id']"
        [showBorders]="true"
        [columnAutoWidth]="true"
        [hoverStateEnabled]="true"
        [noDataText]="'No roles assigned.'"
        height="100%">
        <dxi-column dataField="location_label" caption="Location"></dxi-column>
        <dxi-column dataField="role_label" caption="Role"></dxi-column>
        <dxi-column type="buttons" caption="" [width]="70">
          <dxi-button hint="Remove" icon="trash" [onClick]="onRemoveClick"></dxi-button>
        </dxi-column>
      </dx-data-grid>
    </div>

    <p class="hint">Tip: grant <b>adm_get</b> + <b>adm_update</b> at a location to make this user an admin.</p>
  </div>

  <p class="hint" *ngIf="isNew">Save the user first, then edit them to assign roles.</p>
</div>
